/**
 * Tâche 1421/1422 — Libellé bilingue de la SOURCE d'une transcription.
 *
 * La valeur (`fusionnée`, `whisper`, `whisper-legacy`, `document_textuel`,
 * `inconnue`) est une DONNÉE écrite par le serveur : c'est la clé qui relie
 * une synthèse, un script ou une procédure à la transcription dont elle est
 * issue. On ne la traduit donc qu'à l'AFFICHAGE.
 *
 * Cette table vit HORS composant : elle ne peut pas appeler `tr()` (leçon
 * 1373 — un appel au traducteur hors du hook rend l'écran blanc). Elle porte
 * donc les deux langues sur la même entrée (motif 1324b).
 *
 * `merged` est accepté en plus de `fusionnée` : c'est la graphie de
 * `videos.canonical_transcript_source`, écrite par un autre chemin.
 */
const SOURCES = {
  "fusionnée": { fr: "Fusionnée", en: "Merged" },
  merged: { fr: "Fusionnée", en: "Merged" },
  whisper: { fr: "Whisper", en: "Whisper" },
  fireflies: { fr: "Fireflies", en: "Fireflies" },
  "whisper-legacy": { fr: "Legacy", en: "Legacy" },
  document_textuel: { fr: "Document", en: "Text doc" },
  inconnue: { fr: "Inconnue", en: "Unknown" },
  aucune: { fr: "Aucune", en: "None" },
};

/**
 * Une source inconnue est rendue TELLE QUELLE, pas remplacée par « Inconnue » :
 * afficher « Inconnue » sur une valeur que le serveur a bel et bien écrite
 * ferait disparaître l'information au moment où elle est la plus utile.
 */
export function libelleSource(source, lang) {
  if (!source) return "";
  const entree = SOURCES[String(source).trim().toLowerCase()];
  if (!entree) return String(source);
  return lang === "fr" ? entree.fr : entree.en;
}

export const SOURCES_CONNUES = Object.keys(SOURCES);
